import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { logout } from 'app/store/login/logged-user/logged-user.actions';
import { loggedUser } from 'app/store/login/logged-user/logged-user.selectors';
import { PrettyDebt } from 'core/http/lg-logistic-rest-api/Auth/project.service';
import { TokenService } from 'core/http/lg-logistic-rest-api/Auth/token.service';
import { ownedError } from 'core/utils/owned-error';
import { selectFirst } from 'core/utils/rx-common';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProjectsComponent {
  private _debts = this.route.snapshot.data.debts;

  get debts(): PrettyDebt[] {
    return this._debts;
  }

  constructor(
    private route: ActivatedRoute,
    private tokenService: TokenService,
    private store$: Store,
  ) { }

  logout(): void {
    this.store$.pipe(
      selectFirst(loggedUser),
      switchMap((user) => {
        if (!(user && user.accessToken)) {
          throw ownedError(new Error('Access token is missing'), 'authentication');
        }

        return this.tokenService.revoke(user.accessToken);
      }),
    ).subscribe(() => this.store$.dispatch(logout()));
  }
}
